import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const MAX_FAVORITES = 10;

export default new Vuex.Store({
  state: {
    beds: [],
    baths: [],
    maxRent: 5000,
    minRent: null,
    availFrom: "",
    availTo: "",
    pets: [],
    noFee: false,
    photosOnly: true,
    locations: [],
    streetName: "",
    listingIDs: "",

    favoriteListings: [],
    admin: false
  },
  getters: {
    listingIsInFavoriteListings: state => itemWithID => {
      return state.favoriteListings.some(listing => itemWithID.ID === listing.ID)
    },
    listingIsFavoriteListingsFull: state => state.favoriteListings.length >= MAX_FAVORITES
  },
  mutations: {
    updateBeds(state, payload){ state.beds = [].concat(payload) },
    updateBaths(state, payload){ state.baths = [].concat(payload) },
    updatePets(state, payload){ state.pets = [].concat(payload) },
    updateLocations(state, payload){ state.locations = [].concat(payload) },

    updateMaxRent(state, payload){ state.maxRent = payload },
    updateMinRent(state, payload){ state.minRent = payload },
    updateAvailFrom(state, payload){ state.availFrom = payload },
    updateAvailTo(state, payload){ state.availTo = payload },
    updateNoFee(state, payload){ state.noFee = payload },
    updatePhotosOnly(state, payload){ state.photosOnly = payload },
    updateStreetName(state, payload){ state.streetName = payload },
    
    updateListingIDs(state, payload){ 
      state.listingIDs = payload.replace(/[^\d,]/g,'');
    },

    listingAddFavorite(state, payload){
      if((!state.favoriteListings.some(listing => payload.ID === listing.ID))
          && state.favoriteListings.length < MAX_FAVORITES){
        state.favoriteListings.push(payload);
      }
    },
    listingRemoveFavorite(state, payload){
      state.favoriteListings = state.favoriteListings.filter(listing => payload.ID !== listing.ID);
    },
    listingClearFavorites(state){
      state.favoriteListings = [];
    },

    resetSearchParameters(state){
      state.beds = [];
      state.baths = [];
      state.maxRent = 5000;
      state.minRent = null;
      state.availFrom = "";
      state.availTo = "";
      state.pets = [];
      state.noFee = false;
      state.photosOnly = true;
      state.locations = [];
      state.streetName = "";
      state.listingIDs = "";
    },

    updateAdmin(state, payload){ state.admin = payload },
  }
})